const contactMeForm = {
    requiredField: 'שדה חובה',
    invalidEmail: 'כתובת אימייל אינה תקינה',
    name: 'שם',
    namePlaceholder: 'השם שלך',
    email: 'אימייל',
    emailPlaceholder: 'you@company.com',
    message: 'הודעה',
    messagePlaceholder: 'על מה תרצו לדבר?',
    submit: 'שליחת הודעה',
};

export default contactMeForm;
